const s = (_: string | void | undefined) => Symbol(_ as string);

export const TypesGame = {
    model: s(),
    cookieModel: s(),
    levelModel: s(),
    inputManager: s(),
    skinManager: s(),
    spritesPool: s(),
    actions: {
        startGame: s(),
        burst: s(),
        createMap: s(),
        createMapPart: s(),
        submitContextScore: s(),
        endStage: s(),
        giftPopup: s(),
        levelCompletePopup: s(),
        loadLevel: s(),
        battleResultsPopup: s(),
        winPopup: s(),
        tournamentCreate: s(),
        tournamentPostScore: s(),
        tournamentReShare: s(),
        suggestAuthorizeAction: s(),
        syncYandexLeaderboardsAction: s(),
        levelRestartAfterYandexLoginAction: s(),
        bannerControllerGameDistribution: s(),
        updateBotLevelAction: s(),
        readRemoteConfigAction: s()
    },
    botPresetsModel: s(),
    botLogic: s(),
    botCalculationLogic: s(),
    screens: {
        referral: s("screen.REFERRAL"),
    },
    views: {
        fieldClass: s(),
        fieldInstance: s(),
        fighter: s(),
        arrows: s(),
        arrow: s(),
        state: s(),
        stateShape: s(),
        population: s()
    }
};
